<script setup lang="ts">
import { RefreshCwIcon, XIcon } from 'lucide-vue-next';

defineProps<{ phase: 'searching' | 'found' | 'empty'; progress: number }>();

const emits = defineEmits<{ dismiss: [] }>();

const cardReference = useTemplateRef<HTMLElement>('cardReference');

// Horizontal only: the card sits over the list, a vertical swipe on it is the user scrolling.
useSwipe(cardReference, {
  onSwipeEnd: (_event, direction) => {
    if (direction === 'left' || direction === 'right') {
      emits('dismiss');
    }
  },
});
</script>

<template>
  <div
    ref="cardReference"
    class="flex w-full max-w-md flex-col gap-3 rounded-2xl border bg-background p-4 shadow-lg lg:w-96"
  >
    <div class="flex items-start justify-between gap-3">
      <div class="flex flex-col gap-1">
        <div class="flex items-center gap-2 text-sm font-semibold text-text-primary-900">
          <UiCustomAnimatedCheckIcon
            v-if="phase === 'found'"
            class="size-5 shrink-0 text-green-700"
          />
          <UiCustomAnimatedSearchXIcon
            v-else-if="phase === 'empty'"
            class="size-5 shrink-0 text-orange-700"
          />
          <RefreshCwIcon
            v-else
            aria-hidden="true"
            class="size-5 shrink-0 animate-spin-slow text-brand-primary-700"
          />
          <span>{{ $t(`components.results.backgroundSearch.${phase}Title`) }}</span>
        </div>
        <p class="text-sm font-normal text-text-secondary-600">
          {{ $t(`components.results.backgroundSearch.${phase}Description`) }}
        </p>
      </div>
      <UiButton
        variant="tertiary"
        color="gray"
        size="icon"
        class="size-5 shrink-0 text-foreground hover:bg-transparent [&_svg]:size-5"
        :aria-label="$t('components.common.closeToast')"
        @click="emits('dismiss')"
      >
        <XIcon />
      </UiButton>
    </div>
    <UiProgress
      :model-value="phase === 'searching' ? progress : 100"
      class="h-1.5"
      :class="phase === 'found' ? 'bg-green-100' : ''"
      :indicator-class="phase === 'found' ? 'bg-green-700' : 'bg-brand-primary-700'"
    />
  </div>
</template>
